import PropTypes from "prop-types"
import React from "react"

class ErrorMessage extends React.Component {
  render() {
    if (this.props.children) {
      return (
        <div className="text-danger bs-mt-2 font-semibold">
          {this.props.children}
        </div>
      )
    } else {
      return null
    }
  }
}

ErrorMessage.propTypes = {
  children: PropTypes.node,
}

export default ErrorMessage
